import React from 'react'
import Intro from '../../intro_sections/Intro'
import './main_services.css'
const Privacy_Policy = () => {
    return (
      
        <>
              <Intro name='Privacy Policy' link="Privacy Policy"/>


<section className='Privacy_Policy'>
    <div className='container'>      
    <div className='row'>
                    
        <div className='col-lg-8'>
            <h3>The DexignZone Privacy Policy was updated on 20 July 2022.</h3>
            <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, Contact Us and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>

            <h3>What personal information we collect</h3>
            <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>                             
                              
            <h3>Who We Are and What This Policy Covers</h3>
    <ul>
                <li> <i className="fa-solid fa-check"></i> </li>
                <li>The DexignLab Privacy Policy was updated on 25 June 2018. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's</li>
    </ul>
            
    <ul>
                <li> <i className="fa-solid fa-check"></i> </li>
                <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</li>
    </ul>
            
    <ul>
                <li> <i className="fa-solid fa-check"></i> </li>
                <li>Remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</li>
    </ul>
            
    <ul>
                <li> <i className="fa-solid fa-check"></i> </li>
                <li>Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</li>
    </ul>
        
    <ul>    
            <li> <i className="fa-solid fa-check"></i> </li>
            <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the dummy book.</li>
    </ul>   









    </div>                    




</div>                       
</div>
</section>
            
   </>         
  )
}

export default Privacy_Policy